import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateGmailIsConnecting = mutatorAction('updateGmailIsConnecting', function (isConnecting) {
    var store = connectedAccountsStore();
    store.connectGmailState.isConnecting = isConnecting;
});
//# sourceMappingURL=updateGmailIsConnecting.js.map